import React from 'react';

const AdventureSection = () => {
  return (
    <div className="section-full p-t150 p-b120 site-bg-dark twm-step-towards-section-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
      <div className="twm-half-bg-pic" style={{ backgroundImage: 'url(images/half-bg-pic.jpg)' }}></div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            {/* TITLE START */}
            <div className="section-head left">
              <div className="twm-sm-title left">One step towards you</div>
              <h2 className="twm-large-title site-text-white">Let's Your Adventure Begin</h2>
            </div>
            {/* TITLE END */}
          </div>
        </div>

        <div className="section-content">
          <div className="row twm-step-towards-section">
            {/* Section Item 1 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img src="images/icons/label.png" alt="image" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">Deals For Every Budget</h3>
                  <p>
                  Book cars, vans, bikes, and packages at unbeatable prices worldwide with AB Ghule Cabs. Enjoy affordable travel without compromising on comfort and reliability.
                  </p>
                </div>
              </div>
            </div>

            {/* Section Item 2 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img src="images/icons/customer-support.png" alt="image" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">24/7 Road Assistance</h3>
                  <p>
                  We are ready to assist you with dependable service and support. With AB Ghule Cabs, you can move forward with confidence and peace of mind. 
                  </p>
                </div>
              </div>
            </div>

            {/* Section Item 3 */}
            <div className="col-xl-4 col-lg-4 col-md-4 m-b30">
              <div className="twm-icon-style-left large-set in-dark-area">
                <div className="twm-media">
                  <img src="images/icons/parking-area.png" alt="image" />
                </div>
                <div className="twm-content">
                  <h3 className="twm-title">Free Pick-Up & Drop-Off</h3>
                  <p>
                  Experience added convenience with our free pickup and drop-off services. At AB Ghule Cabs, we ensure your car rental experience is smooth and hassle-free, making your journey even easier.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdventureSection;
